import { useMutation } from '@tanstack/react-query';

import { BusinessToolFormApi } from '../businessToolForm.api';
import { IUpdateBusinessPlanChapterParams, IUpdateBusinessPlanChapterResponse } from '../types';

export const useUpdateBusinessPlanChapter = ({
  onSuccess,
}: {
  onSuccess?:
    | ((
        data: IUpdateBusinessPlanChapterResponse,
        variables: IUpdateBusinessPlanChapterParams,
        context: unknown,
      ) => Promise<unknown> | unknown)
    | undefined;
} = {}) => {
  return useMutation({
    mutationFn: BusinessToolFormApi.updateChapter,
    onSuccess,
    retry: 3,
    retryDelay: 5000,
  });
};
